<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wQLJZK/tc-custom/9781614239055.jpg?1702530540655" alt="This image is the cover for the book Remarkable Women of Old Saybrook, American Heritage"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Remarkable Women of Old Saybrook, American Heritage
      </h1>
      <p class="bookDescription body article font2">
        <p>Situated at the mouth of the Connecticut River, Old Saybrook has been home to generations of remarkable women. The women of this quintessentially New England town have faced and overcome overwhelming adversity to leave indelible marks on their town and its history. Katharine Houghton Hepburn, mother of the legendary actress Katharine Hepburn, organized the Hartford Political Equality League to battle for women's right to vote. Anna Louise James fought to become the first black female pharmacist in Connecticut, and she took care of her community, serving them medicine as well as ice cream sodas at James Pharmacy. There is also local restaurateur Steffie Walters, who after emigrating from Austria remained at the helm of the much-loved shore eatery Dock and Dine for eleven years. Historian Tedd Levy chronicles the achievements of these extraordinary women who broke barriers, changed their communities and expanded opportunities for future generations.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tedd Levy
      </h2>
      
      <p class="authorDescription body article">Tedd Levy is a former teacher and educational consultant who now devotes much of his time to writing about local history. He has written numerous articles on teaching history, educational issues, and public affairs. He is the co-founder of Connecticut History Day and currently serves on the Board of Trustees of the Old Saybrook Historical Society.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dc7b8b44